import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../api/api";
import { Pie } from "react-chartjs-2";
import { Chart, ArcElement, Legend, Tooltip } from "chart.js";
Chart.register(ArcElement, Legend, Tooltip);

interface SAProps {
  title: string;
}

function PieChart({ title }: { title: string }) {
  const [sectorAllocation, setSectorAllocation] = useState<any>(null);
  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchDataTypes("SectorAllocation", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setSectorAllocation(response);
      });
  }, []);

  const data = {
    labels:
      sectorAllocation &&
      sectorAllocation.map((e: any) => {
        return e.sectorName;
      }),
    datasets: [
      {
        label: "# of Votes",
        data:
          sectorAllocation &&
          sectorAllocation.map((e: any) => {
            return e.allocationPercentage;
          }),
        backgroundColor: [
          "rgb(59,125,221)",
          "rgb(40,167,69)",
          "rgb(67,67,72)",
          "rgb(255,196,59)",
          "rgb(32,201,151)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderWidth: 1,
      },
    ],
  };
  return (
    <div className="card w-100">
      <div className="card-header">
        <h5 className="card-title">{title}</h5>
      </div>
      <div className="card-body">
        <div className="chart chart-xs">
          <div className="chartjs-size-monitor">
            <div className="chartjs-size-monitor-shrink">
              <div className="">
                <Pie
                  data={data}
                  options={{
                    elements: {
                      point: {
                        radius: 1,
                      },
                    },

                    plugins: {
                      legend: {
                        position: "bottom",
                        labels: {
                          usePointStyle: true, //for style circle
                        },
                      },
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { PieChart };
